<template>
  <div
    class="input-group input-group-sm input-group-solid"
  >
    <input
      v-model="teamAssetsFilterTitle"
      type="text"
      class="form-control"
      placeholder="search..."
    />
    <div class="input-group-append">
      <span class="input-group-text">
        <i class="fal fa-search icon-sm"></i>
      </span>
    </div>
  </div>
</template>

<script>
import { useTeamAssets } from './use-team-assets'
export default {
  name: 'TeamAssetSearch',
  setup () {
    const { teamAssetsFilterTitle } = useTeamAssets()

    return {
      teamAssetsFilterTitle
    }
  }
}
</script>
